import React, { Component } from 'react';

export default class TimeZone extends Component {
  render() {
    const { className } = this.props,
          description = this.props.description ? this.props.description : 'Timezone:',
          content = `${description} ${this.props.timeZone}`;

    return (
      <p className={`${className ? className : 'text-right'} timezone`} style={{ fontSize: '11px', margin: '5px 5px 0' }}>
        {content}
      </p>
    );
  }
}